module.exports = __webpack_public_path__ + "img/arrow_left_alt.287d976b.svg";